import {
    BannerAlert,
    BannerAlertProps
} from "../../../../libraries/design/components/banner-alert/src/banner-alert.tsx";

const UniformBannerAlert = (props: BannerAlertProps) => {
    return <BannerAlert {...props} />;
};

export default UniformBannerAlert;
